import { connect } from 'react-redux'

import { selectIntegrationSettingsSidebarFieldsToDisplayForProvider } from 'ducks/integrations'
import { doUnlinkJiraCloudIssue } from 'ducks/integrations/jiraCloud'
import LinkedJiraCloudIssue from './view'

const select = state => ({
  fieldsToDisplay: selectIntegrationSettingsSidebarFieldsToDisplayForProvider(
    state,
    { provider: 'jira_cloud' }
  ),
})

const perform = {
  onUnlink: doUnlinkJiraCloudIssue,
}

export default connect(select, perform)(LinkedJiraCloudIssue)
